import React, { useContext, useEffect } from 'react';
import PackageBannerMobileComponent from '../PackageBannerMobileComponent/PackageBannerMobileComponent';
import { getAppEnv } from '../../../config/env';
import { Context } from '../../AppContext';
import { isMobile, isSSR } from '../../utils/commonUtils';
// import { logRttEventLogger } from '../../logRttRequestBuilder';
// import { logRttEventLogger } from '../../logRttRequestBuilder';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

interface PackageBannerProps {
  packageData: any;
  pageUrl: string;
}

const PackageBanner = React.memo(
  ({ packageData, pageUrl }: PackageBannerProps) => {
    const { trackTemplateEvent, omniUrlArgs } = useContext(Context);
    useEffect(() => {
      if (isMobile()) {
        setTimeout(() => {
          // logRttEventLogger({omniUrlArgs, eventName: 'Cab_SEO_Packages_Mobile_Banner_Shown',pageUrl });
          trackTemplateEvent(`Cab_SEO_Packages_Mobile_Banner_Shown`);
        }, 2000);
      } else {
        setTimeout(() => {
          // logRttEventLogger({omniUrlArgs, eventName: 'Cab_SEO_Packages_Desktop_Banner_Shown',pageUrl });
          trackTemplateEvent(`Cab_SEO_Packages_Desktop_Banner_Shown`);
        }, 2000);
      }
    }, []);
    return (
      <div className="packageDataContainer" style={{ height: '100px' }}>
        <div className="mobileShow">
          <PackageBannerMobileComponent
            packageData={packageData}
            pageUrl={pageUrl}
          />
        </div>
        <img
          height={100}
          src={`${PUBLIC_URL}/static/public/${packageData.dweb_banner.image}`}
          alt="Package Banner"
          onClick={() => {
            // logRttEventLogger({omniUrlArgs, eventName: 'Cab_SEO_Packages_Desktop_Banner_Clicked',pageUrl });
            window.location.href = `${packageData.dweb_banner.redirection_url}&${omniUrlArgs}`;
            trackTemplateEvent(`Cab_SEO_Packages_Desktop_Banner_Clicked`);
          }}
          className={'desktopShow cursorPointer'}
        />
      </div>
    );
  }
);

export default PackageBanner;
